import fetch from '../api/fetch'

/**
 * 	Action to fetch user detail
 *
 *  @param     {string} URL [/api/v1/users]
 * 	@method GET
 */

export function fetchUserDetail() {

    return {
        type: 'FETCH_USER_DETAIL',
        payload: fetch('/session', { method: 'GET' }),
    }
}

/**
 * 	Action to change account details of the user
 *
 * 	@param 	{String} URL [/api/v1/users]
 * 	@param 	{Object} user [Object with new user details]
 * 	@method POST
 */
export function saveAccountChanges(details: object) {
    return {
        type: 'CHANGE_ACCOUNTDETAILS',
        payload: fetch('/users', { method: 'PUT', body: details }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/userDetail.ts